import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ComfyUIIcon from "../../../assets/Integrations/icons/comfyui.png";
import FigmaIcon from "../../../assets/Integrations/icons/figma.png";
import PhotoshopIcon from "../../../assets/Integrations/icons/photoshop.png";
import DownloadModelIcon from "../../../assets/TailoredGeneration/icons/api-download-model.svg";
import IframeIcon from "../../../assets/common/icons/enable-iframe.svg";
import APIIcon from "../../../assets/common/icons/integrate-api.svg";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import BriaButtonGroup from "../../../components/common/BriaButtonGroup/BriaButtonGroup";
import CopyToClipboardButton from "../../../components/common/CopyToClipboardButton/CopyToClipboardButton";
import DownloadModelPopup from "../../../components/common/DownloadModelPopup/DownloadModelPopup.tsx";
import LinkConstants from "../../../constants/LinkConstants";
import RouterConstants from "../../../constants/RouterConstants";
import { useAppStore } from "../../../hooks/useStores";
import PhotoshopInstallationPopup from "../Models/Popups/PhotoshopInstallationPopup/PhotoshopInstallationPopup";
import SuggestAccessMethodPopup from "../Models/Popups/SuggestAccessMethodPopup/SuggestAccessMethodPopup";
import TgRequestAccessButton from "./RequestAccess/TgRequestAccessButton";

const TgModelsAccess = () => {
	const { t } = useTranslation("tg", { keyPrefix: "accessMethods" });
	const { t: tTg } = useTranslation("tg");
	const { appStore } = useAppStore();

	const [popupState, setPopupState] = useState({
		model: false,
		photoshop: false,
		suggest: false,
	});
	const [openContactUs, setOpenContactUs] = useState(false);

	const closePopup = (key: keyof typeof popupState) => () => setPopupState({ ...popupState, [key]: false });

	const cards: ConsoleAPICardProps[] = [
		{
			image: APIIcon,
			imageType: "icon",
			header: t("cards.api.header"),
			description: t("cards.api.description"),
			buttons: (
				<TgRequestAccessButton>
					<BriaButtonGroup>
						<BriaButton
							buttonType="textSmall"
							onClick={() => window.open(RouterConstants.AUTH_KEYS.fullPath, "_blank")}
						>
							{t("cards.api.primaryBtn")}
						</BriaButton>
						<BriaButton
							buttonType="textSmall"
							onClick={() => window.open(LinkConstants.BRIA_API_TG_VIDEO_GENERATION, "_blank")}
						>
							{t("cards.api.secondaryBtn")}
						</BriaButton>
					</BriaButtonGroup>
				</TgRequestAccessButton>
			),
		},
		{
			image: IframeIcon,
			imageType: "icon",
			header: t("cards.iframe.header"),
			description: t("cards.iframe.description"),
			buttons: (
				<TgRequestAccessButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => window.open(RouterConstants.ACCOUNT_IFRAMES.fullPath, "_blank")}
					>
						{t("cards.iframe.primaryBtn")}
					</BriaButton>
				</TgRequestAccessButton>
			),
			onClick: () => window.open(RouterConstants.ACCOUNT_IFRAMES.fullPath, "_blank"),
		},
		{
			image: FigmaIcon,
			imageType: "icon",
			header: t("cards.figma.header"),
			description: t("cards.figma.description"),
			buttons: (
				<TgRequestAccessButton>
					<BriaButtonGroup>
						<BriaButton
							buttonType="textSmall"
							onClick={() => window.open(LinkConstants.BRIA_FIGMA_PLUGIN, "_blank")}
						>
							{t("cards.figma.installBtn")}
						</BriaButton>
					</BriaButtonGroup>
				</TgRequestAccessButton>
			),
		},
		{
			image: DownloadModelIcon,
			imageType: "icon",
			header: t("cards.model.header"),
			description: t("cards.model.description"),
			buttons: (
				<TgRequestAccessButton>
					<BriaButton buttonType="textSmall" onClick={() => setOpenContactUs(true)}>
						{t("cards.model.primaryBtn")}
					</BriaButton>
				</TgRequestAccessButton>
			),
			onClick: () => setOpenContactUs(true),
		},
		{
			image: PhotoshopIcon,
			imageType: "icon",
			header: t("cards.photoshop.header"),
			description: t("cards.photoshop.description"),
			buttons: (
				<TgRequestAccessButton>
					<BriaButtonGroup>
						<BriaButton
							buttonType="textSmall"
							onClick={() => {
								window.open(LinkConstants.ADOBE_MARKETPLACE, "_blank");
								appStore.logPhotoshopGoToAdobeMarketplace();
							}}
						>
							{t("cards.photoshop.primaryBtn")}
						</BriaButton>
					</BriaButtonGroup>
				</TgRequestAccessButton>
			),
		},
		{
			image: ComfyUIIcon,
			imageType: "icon",
			header: t("cards.comfyUi.header"),
			description: t("cards.comfyUi.description"),
			buttons: (
				<TgRequestAccessButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => window.open(LinkConstants.BRIA_COMFYUI_TAILORED_GEN, "_blank")}
					>
						{t("cards.comfyUi.primaryBtn")}
					</BriaButton>
					<CopyToClipboardButton
						loading={appStore.isLoading}
						getTextToCopy={appStore.getComfyUIAPIToken}
						buttonText={t("cards.comfyUi.copyComfyUIAPIToken")}
						buttonType="textSmall"
						hideIcon
					/>
				</TgRequestAccessButton>
			),
		},
	];

	const rightActions = (
		<>
			<BriaButton
				buttonType="secondarySmall"
				onClick={() => window.open(RouterConstants.ACCOUNT_IFRAMES.fullPath, "_blank")}
			>
				{tTg("iframe.primaryButton")}
			</BriaButton>
		</>
	);

	return (
		<>
			<ConsoleAPILayout description={t("description")} rightActions={rightActions}>
				<ConsoleAPICards cards={cards} />
			</ConsoleAPILayout>

			<SuggestAccessMethodPopup open={popupState.suggest} onClose={closePopup("suggest")} />
			<PhotoshopInstallationPopup
				open={popupState.photoshop}
				onClose={closePopup("photoshop")}
				onClick={() => {
					window.open(LinkConstants.ADOBE_MARKETPLACE, "_blank");
					appStore.logPhotoshopGoToAdobeMarketplace();
				}}
			/>
			<DownloadModelPopup
				open={openContactUs}
				onClose={() => setOpenContactUs(false)}
				requestFeature={t("supportPopup.page")}
				title={t("supportPopup.title")}
				description={t("supportPopup.description")}
			/>
		</>
	);
};

export default observer(TgModelsAccess);
